/**
 * RFC 6350/5545 line folding — shared by Contacts' vCard output and
 * Calendar's iCalendar output, which both inherit the same rule from their
 * common vCard/iCalendar content-line grammar (RFC 5322-style folding):
 * lines cap at 75 octets, continuation lines are CRLF followed by one space.
 */

export const CRLF = "\r\n";

const FOLD_WIDTH = 75;

/** Folds one logical content line at FOLD_WIDTH octets, never splitting a UTF-8 character. */
export function foldLine(line: string): string {
    const bytes = new TextEncoder().encode(line);
    if (bytes.length <= FOLD_WIDTH) {
        return line;
    }

    const decoder = new TextDecoder();
    const parts: string[] = [];
    let start = 0;
    let width = FOLD_WIDTH;
    while (start < bytes.length) {
        let end = Math.min(start + width, bytes.length);
        // Never split a multi-byte UTF-8 sequence — back off until the next
        // byte is not a continuation byte (0b10xxxxxx).
        while (end < bytes.length && (bytes[end]! & 0xc0) === 0x80) {
            end -= 1;
        }
        parts.push(decoder.decode(bytes.slice(start, end)));
        start = end;
        width = FOLD_WIDTH - 1; // continuation lines lose one column to the leading space
    }
    return parts.join(`${CRLF} `);
}
